import { FeatureDefinition } from '@growthbook/growthbook'

export enum FeatureFlagKey {
  VISIBLE_LOCALES = 'nuxt-visible-locales',
  PAYMENT_SERVICE_PROVIDER = 'payment-service-provider',
  PREVIOUS_SEARCH_ON_TOP = 'previous_search_on_top',
  BETA_RANKER = 'beta-ranker',
  GOOGLE_MAP_REVIEW = 'nuxt-google-map-review',
}

const FeatureFlags: Record<string, FeatureDefinition> = {
  /**
   * 開放的語系
   */
  [FeatureFlagKey.VISIBLE_LOCALES]: {
    defaultValue: 'en',
  },
  /**
   * 使用哪家金流商
   * TAPPAY: 1
   * PAYMENTS91APP: 2
   * NEWEBPAY: 3
   */
  [FeatureFlagKey.PAYMENT_SERVICE_PROVIDER]: {
    defaultValue: 3,
  },
  /**
   * search是否將之前搜尋顯示在前面
   * false: 不顯示
   * true: 顯示
   */
  [FeatureFlagKey.PREVIOUS_SEARCH_ON_TOP]: {
    defaultValue: false,
  },
  /**
   * beta-ranker
   * false: 不經過
   * true: 經過
   */
  [FeatureFlagKey.BETA_RANKER]: {
    defaultValue: false,
  },
  /**
   * 多顯示 Google Map 評論
   * false: 不顯示
   * true: 顯示
   */
  [FeatureFlagKey.GOOGLE_MAP_REVIEW]: {
    defaultValue: false,
  },
}

export type FlagKey = string

export default FeatureFlags
